import { useParams } from "react-router-dom";

/**
 * Store slug from the current route (`/:locale/:storeSlug/...`).
 * App-wide hook — every module that talks to the seller API keys its
 * queries on this value.
 */
export function useSellerStoreSlug() {
  const { storeSlug = "" } = useParams();
  return storeSlug;
}
